export default "__VITE_ASSET__CxpbJTn1__"